import React, { Component } from 'react';

import i18n from 'helper/i18n';

import withSequenceState from 'components/hoc/withSequenceState';
import Sequences from 'defs/sequences';

import withVirtualPageView from 'components/hoc/withVirtualPageView';
import { WithVirtualPageView } from 'components/hoc/withVirtualPageView';

import Loader from 'components/atoms/Loader';
import Card from 'containers/molecules/Card/Favorite';
import noop from 'helper/noop';
import { WithRouterType } from 'types/withRouter';

export type FavoritesDetailViewProps = WithRouterType &
	WithVirtualPageView & {
		doLockBody: () => void;
		doLoadSelectedFavoriteData: (type: string, id: string) => void;
		data: Object;
		isSequenceLoading: boolean;
	};

export type SlugMapType = { [key: string]: string };

function slugLabel(t: string): string {
	return i18n(`react.impulsCoach.routes.favorites.detail.${t.toLocaleLowerCase().replace(/-/gi, '')}.href`);
}

const slugMap: SlugMapType = {
	[slugLabel('tip')]: 'TIP',
	[slugLabel('workout')]: 'WORKOUT',
	[slugLabel('todo')]: 'TODO',
	[slugLabel('recipe')]: 'RECIPE',
	[slugLabel('product')]: 'PRODUCT',
};

const resolveSlugToType: (slug: string) => string = (slug: string) => slugMap[slug] || '';

export class FavoritesDetailView extends Component<FavoritesDetailViewProps> {
	public static displayName = 'FavoritesDetailView';
	public static defaultProps = {
		trackVirtualPageView: noop,
	};

	public tracked = false;

	public componentDidMount() {
		this.props.doLockBody();
		this.props.doLoadSelectedFavoriteData(this.type, this.id || '');
	}

	get type(): string {
		const internalType: string = this.props.match ? `${this.props.match.params.type}` || '' : '';
		return resolveSlugToType(internalType);
	}

	get id(): string {
		return this.props.match ? `${this.props.match.params.id || ''}` : '';
	}

	public render() {
		const { history, data, isSequenceLoading, trackVirtualPageView } = this.props;

		if (isSequenceLoading) {
			return <Loader />;
		}

		if (!this.tracked) {
			trackVirtualPageView({});
			this.tracked = true;
		}

		return <Card {...(data as any)} history={history} />;
	}
}

export default withSequenceState(withVirtualPageView(FavoritesDetailView), [Sequences.FAVORITE_IS_LOADING]);
